<template>
  <div
    class="sport-container"
    :class="`sport-match-color-${sport.id}`">
    <sport-header :sport="sport" />
    <match
      v-for="idMatch in sport.matchIds"
      :key="idMatch"
      :id-match="idMatch"
    />
  </div>
</template>

<script>
import SportHeader from './SportHeader.vue';
import Match from './Match.vue';

export default {
  name: 'Sport',
  components: { SportHeader, Match },
  props: {
    sport: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.sport-container {
  float: left;
  width: 100%;
}

.sport-container /deep/ {
  .grid-left {
    position: relative;
    float: left;
    width: 38%;
    height: 100%;
  }

  .grid-right {
    position: relative;
    float: left;
    width: 62%;
    height: 100%;
  }
}
</style>
